import prompt from './service';
export default {
    prompt
};
